import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=68ac59f2&"
import script from "./AppNavItem.vue?vue&type=script&lang=js&"
export * from "./AppNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports